module.exports = __webpack_public_path__ + "static/media/Ajisola-Abiola.d43f106d.png";